import { preload } 				from './modules/mod_preload'
import { navigation } 			from './modules/mod_navigation'
import { counter } 				from './modules/mod_counter'
import { slider } 				from './modules/mod_slider'
import { dialog, accordion } 	from './modules/mod_dialog'
import { aos } 					from './modules/mod_aos';
import { bannertextJumplinks } 	from './modules/mod_jumplinks'
import { articleToc } 			from './modules/mod_article-toc'
import { softgardenApply } 		from './modules/mod_softgarden_apply'
import { ynAccordionsOpen, branchenAccordionImages } from './modules/mod_yn_accordions'
import { truncate } 			from './modules/mod_truncate'
import { sunburst } 			from './modules/mod_sunburst'
import { listingMore } 			from './modules/mod_listing_more'

window.onload = function () {
	preload()
	navigation()
	counter()
	slider()
	dialog()
	accordion()
	aos()
	bannertextJumplinks()
	articleToc()
	softgardenApply()
	ynAccordionsOpen()
	branchenAccordionImages()
	truncate()
	sunburst()
	listingMore()
}
